/**
 * يحمّل overrides رسائل الهاتف ويحقنها في t() عبر mergeI18nOverrides
 * (دون أن يدوس overrides loaders الأخرى مثل GiftFlow).
 */
import * as React from "react";
import { useQuery } from "@tanstack/react-query";
import { useServerFn } from "@tanstack/react-start";
import { getPhoneMessagesOverrides } from "@/lib/phoneMessagesOverrides.functions";
import { mergeI18nOverrides } from "@/lib/i18n";

export function PhoneMessagesOverridesLoader() {
  const fn = useServerFn(getPhoneMessagesOverrides);
  const { data } = useQuery({
    queryKey: ["phone-messages-overrides"],
    queryFn: () => fn(),
    staleTime: 60_000,
  });
  React.useEffect(() => {
    if (data) mergeI18nOverrides(data);
  }, [data]);
  return null;
}
